import Color from "utils/Color";
import { getTheme } from "..";

export default function MessageBox({children, header, arrowPostionX, arrowPostionY, background, ...rest})
{
  const left = arrowPostionX === "left" ? "left: -5px;" : "right: -5px;";
  const top = arrowPostionY === "top" ? "top: 20px;" : "bottom: 20px;";
  const backgroundColor = Color.rgbToHex(background || getTheme().backgroundColor);

  return (
    <div className="ui-messagebox" {...rest}>
      <div className="ui-messagebox-arrow"></div>
      <div className="ui-messagebox-message">
        <div className="ui-messagebox-message-header">{header}</div>
        <div className="ui-messagebox-message-message">{children}</div>
      </div>
      <style jsx>
      {`
        .ui-messagebox {
          position: relative;
          border-radius: 5px;
          box-shadow: 0 2px 4px 0 rgba(var(--accentColor), 0.15);
          font-weight: 300;
          font-size: 15px;
          box-sizing: border-box;
        }
        .ui-messagebox .ui-messagebox-message {
          position: relative;
          background-color: #${backgroundColor};
          border-radius: 6px;
          padding: 20px;
          z-index: 1001;
        }
        .ui-messagebox .ui-messagebox-message-header:empty {
          display: none;
        }
        .ui-messagebox .ui-messagebox-message-header {
          opacity: 0.5;
        }

        .ui-messagebox-message-header:not(:empty) + .ui-messagebox-message-message:not(:empty) {
          margin-top: 10px;
        }

        .ui-messagebox .ui-messagebox-arrow {
          display: block;
          content: '';
          position: absolute;
          width: 10px;
          height: 10px;
          transform: rotate(45deg);
          background-color: #${backgroundColor};
            box-shadow: 0 2px 4px 0 rgba(var(--accentColor), 0.15);
          z-index: 1000;
          ${top}
          ${left}
        }
      `}
      </style>
    </div>
  );
}

MessageBox.defaultProps = {
  arrowPostionX: "left",
  arrowPostionY: "top"
}